// Generated by purs version 0.15.16
import * as Concur_Core_LiftWidget from "../Concur.Core.LiftWidget/index.js";
import * as Concur_Core_Types from "../Concur.Core.Types/index.js";
import * as Concur_React_DOM from "../Concur.React.DOM/index.js";
import * as Concur_React_Props from "../Concur.React.Props/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as GraphQL_Type from "../GraphQL.Type/index.js";
import * as Internal_Luxon from "../Internal.Luxon/index.js";
import * as Steps_Step3_Editability from "../Steps.Step3.Editability/index.js";
import * as Steps_Step3_Types from "../Steps.Step3.Types/index.js";
import * as Steps_WorkQueue_State from "../Steps.WorkQueue.State/index.js";
import * as Steps_WorkQueue_View from "../Steps.WorkQueue.View/index.js";
import * as Translate from "../Translate/index.js";
import * as Widgets_Attachments from "../Widgets.Attachments/index.js";
import * as Widgets_BetterSelect from "../Widgets.BetterSelect/index.js";
import * as Widgets_Comments from "../Widgets.Comments/index.js";
import * as Widgets_Form from "../Widgets.Form/index.js";
import * as Widgets_Form_Access from "../Widgets.Form.Access/index.js";
import * as Widgets_FormPreview from "../Widgets.FormPreview/index.js";
import * as Widgets_HiddenSelect from "../Widgets.HiddenSelect/index.js";
import * as Widgets_Loading from "../Widgets.Loading/index.js";
import * as Widgets_Signature from "../Widgets.Signature/index.js";
import * as Widgets_Signature_Group from "../Widgets.Signature.Group/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var multiAlternativeWidget = /* #__PURE__ */ Concur_Core_Types.multiAlternativeWidget(Data_Monoid.monoidArray);
var div = /* #__PURE__ */ Concur_React_DOM.div(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var span = /* #__PURE__ */ Concur_React_DOM.span(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var text = /* #__PURE__ */ Concur_React_DOM.text(Concur_Core_LiftWidget.liftWidgetWidget);
var button = /* #__PURE__ */ Concur_React_DOM.button(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var voidRight = /* #__PURE__ */ Data_Functor.voidRight(Concur_React_Props.functorProps);
var notEq = /* #__PURE__ */ Data_Eq.notEq(/* #__PURE__ */ Data_Maybe.eqMaybe(/* #__PURE__ */ GraphQL_Type.eqRNTY(Data_Eq.eqString)));
var notEq1 = /* #__PURE__ */ Data_Eq.notEq(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqString));
var p$prime = /* #__PURE__ */ Concur_React_DOM["p$prime"](multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var map1 = /* #__PURE__ */ Data_Functor.map(Concur_Core_Types.functorWidget);
var map2 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorFn);
var a = /* #__PURE__ */ Concur_React_DOM.a(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var length = /* #__PURE__ */ Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt);
var h1 = /* #__PURE__ */ Concur_React_DOM.h1(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var sigResultF = function (state) {
    return function (v) {
        if (v instanceof Widgets_Signature_Group.SigGroupChanged) {
            return new Steps_Step3_Types.StateF({
                form: state.form,
                doc: state.doc,
                comments: state.comments,
                attachments: state.attachments,
                preview: state.preview,
                signatures: v.value0
            });
        };
        if (v instanceof Widgets_Signature_Group.SigGroupMutation) {
            return new Steps_Step3_Types.DocumentMutationF({
                form: state.form,
                doc: state.doc,
                comments: state.comments,
                attachments: state.attachments,
                preview: state.preview,
                signatures: v.value0
            }, (function () {
                if (v.value1 instanceof Widgets_Signature_Group.SignatureWidgetRequest) {
                    if (v.value1.value0 instanceof Widgets_Signature.UseCapturedSignature) {
                        return new Steps_Step3_Types.SignWithCapturedSignature(state.doc.id, v.value1.value0.value0, v.value1.value0.value1, v.value1.value0.value2);
                    };
                    if (v.value1.value0 instanceof Widgets_Signature.UseSavedSignature) {
                        return new Steps_Step3_Types.SignWithSavedSignature(state.doc.id, v.value1.value0.value0);
                    };
                    if (v.value1.value0 instanceof Widgets_Signature.SendSignatureRequest) {
                        return new Steps_Step3_Types.RequestSignatures([ v.value1.value0.value0 ]);
                    };
                    throw new Error("Failed pattern match at Steps.Step3.FormView (line 150, column 17 - line 156, column 74): " + [ v.value1.value0.constructor.name ]);
                };
                if (v.value1 instanceof Widgets_Signature_Group.SignatureEmailRequests) {
                    return new Steps_Step3_Types.RequestSignatures(v.value1.value0);
                };
                throw new Error("Failed pattern match at Steps.Step3.FormView (line 148, column 61 - line 158, column 54): " + [ v.value1.constructor.name ]);
            })());
        };
        throw new Error("Failed pattern match at Steps.Step3.FormView (line 144, column 20 - line 158, column 54): " + [ v.constructor.name ]);
    };
};
var setTeacherSelect = function (state) {
    return function (teacher) {
        return {
            ui: {
                expandedStudents: state.workQueueUi.expandedStudents,
                expandedForms: state.workQueueUi.expandedForms,
                search: state.workQueueUi.search,
                semester: state.workQueueUi.semester,
                teacher: teacher
            },
            state: {
                forms: state.workQueueState.forms,
                students: state.workQueueState.students,
                documents: state.workQueueState.documents,
                editDocs: state.workQueueState.editDocs,
                currentDoc: state.workQueueState.currentDoc,
                semester: state.workQueueState.semester,
                teacher: map(function (v1) {
                    return v1.value;
                })(Widgets_BetterSelect.selectedItem(teacher))
            }
        };
    };
};
var setSemesterSelect = function (state) {
    return function (semester) {
        return {
            ui: {
                expandedStudents: state.workQueueUi.expandedStudents,
                expandedForms: state.workQueueUi.expandedForms,
                search: state.workQueueUi.search,
                teacher: state.workQueueUi.teacher,
                semester: semester
            },
            state: {
                forms: state.workQueueState.forms,
                students: state.workQueueState.students,
                documents: state.workQueueState.documents,
                editDocs: state.workQueueState.editDocs,
                currentDoc: state.workQueueState.currentDoc,
                teacher: state.workQueueState.teacher,
                semester: map(function (v1) {
                    return v1.value;
                })(Widgets_BetterSelect.selectedItem(semester))
            }
        };
    };
};
var renderLockBanner = function (busy) {
    return function (fstate) {
        var bannerShowsUnlock = function (v) {
            if (v instanceof Steps_Step3_Editability.EditablePrivileged) {
                return true;
            };
            if (v instanceof Steps_Step3_Editability.UneditablePrivileged) {
                return true;
            };
            return false;
        };
        var v = (function (v1) {
            return v1.lockedBanner;
        })(Steps_Step3_Types.formEditability(fstate));
        if (v instanceof Data_Maybe.Nothing) {
            return [  ];
        };
        if (v instanceof Data_Maybe.Just) {
            var msg = Translate.lookupTranslation((function () {
                if (v.value0 instanceof Steps_Step3_Editability.EditablePrivileged) {
                    return "form-locked-banner-message-mutable";
                };
                if (v.value0 instanceof Steps_Step3_Editability.EditableUnprivileged) {
                    return "form-locked-banner-message-mutable-unprivileged";
                };
                if (v.value0 instanceof Steps_Step3_Editability.UneditablePrivileged) {
                    return "form-locked-banner-message";
                };
                if (v.value0 instanceof Steps_Step3_Editability.UneditableUnprivileged) {
                    return "form-locked-banner-message-unprivileged";
                };
                throw new Error("Failed pattern match at Steps.Step3.FormView (line 196, column 39 - line 200, column 84): " + [ v.value0.constructor.name ]);
            })());
            return [ div([ Concur_React_Props.className("lock-banner") ])(append([ div([ Concur_React_Props.className("lock-banner-content") ])([ span([ Concur_React_Props.className("lock-banner-icon"), Concur_React_Props.title(Translate.lookupTranslation("locked")) ])([  ]), span([ Concur_React_Props.className("lock-banner-message") ])([ text(msg) ]) ]) ])((function () {
                var $73 = bannerShowsUnlock(v.value0);
                if ($73) {
                    return [ button(append([ Concur_React_Props.disabled(busy), Concur_React_Props["_type"]("button"), Concur_React_Props.className("btn lock-banner-button") ])((function () {
                        if (busy) {
                            return [  ];
                        };
                        return [ voidRight(Steps_Step3_Types.ToggleLockF.value)(Concur_React_Props.onClick) ];
                    })()))([ text(Translate.lookupTranslation("unlock")) ]) ];
                };
                return [  ];
            })())) ];
        };
        throw new Error("Failed pattern match at Steps.Step3.FormView (line 192, column 32 - line 222, column 10): " + [ v.constructor.name ]);
    };
};
var previewStateChangeF = function (state) {
    return function (pstate) {
        return new Steps_Step3_Types.StateF({
            form: state.form,
            doc: state.doc,
            comments: state.comments,
            attachments: state.attachments,
            signatures: state.signatures,
            preview: pstate
        });
    };
};
var metadataStateChangeF = function (previous) {
    return function (next) {
        var metadataChanged = notEq(map(function (v) {
            return v.id;
        })(previous.workQueueState.teacher))(map(function (v) {
            return v.id;
        })(next.state.teacher)) || notEq1(map(function (v) {
            return v.semester;
        })(previous.workQueueState.semester))(map(function (v) {
            return v.semester;
        })(next.state.semester));
        if (metadataChanged) {
            return new Steps_Step3_Types.WorkQueueMetadataF(next.state, next.ui);
        };
        return new Steps_Step3_Types.WorkQF(new Steps_WorkQueue_View.UIStateChange(next.ui));
    };
};
var formResultF = function (v) {
    return function (v1) {
        if (v1.value0.action instanceof Data_Maybe.Nothing) {
            return new Steps_Step3_Types.StateF({
                doc: v.doc,
                comments: v.comments,
                attachments: v.attachments,
                preview: v.preview,
                signatures: v.signatures,
                form: v1.value0.state
            });
        };
        if (v1.value0.action instanceof Data_Maybe.Just) {
            return new Steps_Step3_Types.ActionF(v1.value0.action.value0, {
                doc: v.doc,
                comments: v.comments,
                attachments: v.attachments,
                preview: v.preview,
                signatures: v.signatures,
                form: v1.value0.state
            });
        };
        throw new Error("Failed pattern match at Steps.Step3.FormView (line 110, column 1 - line 110, column 77): " + [ v.constructor.name, v1.constructor.name ]);
    };
};
var commentResultF = function (state) {
    return function (v) {
        if (v instanceof Widgets_Comments.CommentsChanged) {
            return new Steps_Step3_Types.StateF({
                form: state.form,
                doc: state.doc,
                attachments: state.attachments,
                preview: state.preview,
                signatures: state.signatures,
                comments: v.value0
            });
        };
        if (v instanceof Widgets_Comments.CommentsRequest) {
            return new Steps_Step3_Types.DocumentMutationF(state, (function () {
                if (v.value0 instanceof Widgets_Comments.CreateComment) {
                    return new Steps_Step3_Types.CreateComment(state.doc.id, v.value0.value0);
                };
                if (v.value0 instanceof Widgets_Comments.UpdateComment) {
                    return new Steps_Step3_Types.UpdateComment(state.doc.id, v.value0.value0, v.value0.value1);
                };
                if (v.value0 instanceof Widgets_Comments.RemoveComment) {
                    return new Steps_Step3_Types.DeleteComment(state.doc.id, v.value0.value0);
                };
                throw new Error("Failed pattern match at Steps.Step3.FormView (line 124, column 35 - line 130, column 64): " + [ v.value0.constructor.name ]);
            })());
        };
        throw new Error("Failed pattern match at Steps.Step3.FormView (line 120, column 24 - line 130, column 64): " + [ v.constructor.name ]);
    };
};
var attachmentResultF = function (state) {
    return function (v) {
        if (v instanceof Widgets_Attachments.AttachmentsChanged) {
            return new Steps_Step3_Types.StateF({
                form: state.form,
                doc: state.doc,
                comments: state.comments,
                preview: state.preview,
                signatures: state.signatures,
                attachments: v.value0
            });
        };
        if (v instanceof Widgets_Attachments.AttachmentsRequest) {
            return new Steps_Step3_Types.DocumentMutationF(state, (function () {
                if (v.value0 instanceof Widgets_Attachments.CreateAttachment) {
                    return new Steps_Step3_Types.CreateAttachment(state.doc.id, v.value0.value0);
                };
                if (v.value0 instanceof Widgets_Attachments.RemoveAttachment) {
                    return new Steps_Step3_Types.DeleteAttachment(state.doc.id, v.value0.value0);
                };
                throw new Error("Failed pattern match at Steps.Step3.FormView (line 137, column 35 - line 141, column 70): " + [ v.value0.constructor.name ]);
            })());
        };
        throw new Error("Failed pattern match at Steps.Step3.FormView (line 133, column 27 - line 141, column 70): " + [ v.constructor.name ]);
    };
};
var renderFormFillState = function (signatures) {
    return function (busy) {
        return function (state) {
            var formContextForBusy = (function () {
                var context = Steps_Step3_Types.formContext(state.workQueueCache)(state.fillState);
                if (busy) {
                    return {
                        account: context.account,
                        autofillArgs: context.autofillArgs,
                        curIndex: context.curIndex,
                        doc: context.doc,
                        isAutofilling: context.isAutofilling,
                        parentIds: context.parentIds,
                        access: {
                            "default": Widgets_Form_Access.AccessView.value,
                            fields: [  ]
                        }
                    };
                };
                return context;
            })();
            var semesterTranslation = (function () {
                if (state.fillState.doc.can.update) {
                    return "semester-hidden-select";
                };
                if (Data_Boolean.otherwise) {
                    return "semester-hidden-select-locked";
                };
                throw new Error("Failed pattern match at Steps.Step3.FormView (line 98, column 5 - line 100, column 54): " + [  ]);
            })();
            return div([ Concur_React_Props.className("step-3-right form-submission relative") ])(append(renderLockBanner(busy)(state.fillState))(append((function () {
                var $101 = Steps_WorkQueue_State["formForSelected$prime"](state.workQueueState);
                if ($101) {
                    return [  ];
                };
                return [ div([ Concur_React_Props.className("error") ])([ text(Translate.lookupTranslation("must-select-teacher-semester")) ]) ];
            })())(append([ div([ Concur_React_Props.className("teacher-semester-selections") ])([ p$prime([ text(Translate.lookupTranslation(semesterTranslation)) ]), (function () {
                var $102 = busy && state.fillState.doc.can.update;
                if ($102) {
                    return Widgets_HiddenSelect.hiddenSelectDisabled(state.workQueueUi.semester);
                };
                if (state.fillState.doc.can.update) {
                    return map1(map2(metadataStateChangeF(state))(setSemesterSelect(state)))(Widgets_HiddenSelect.hiddenSelect(state.workQueueUi.semester));
                };
                return Widgets_HiddenSelect.hiddenSelectLabel(state.workQueueUi.semester);
            })(), p$prime([ text(Translate.lookupTranslation("teacher-hidden-select")) ]), (function () {
                var $104 = busy && state.fillState.doc.can.update;
                if ($104) {
                    return Widgets_HiddenSelect.hiddenSelectDisabled(state.workQueueUi.teacher);
                };
                if (state.fillState.doc.can.update) {
                    return map1(map2(metadataStateChangeF(state))(setTeacherSelect(state)))(Widgets_HiddenSelect.hiddenSelect(state.workQueueUi.teacher));
                };
                return Widgets_HiddenSelect.hiddenSelectLabel(state.workQueueUi.teacher);
            })() ]), map1(formResultF(state.fillState))(Widgets_Form.formWidget(formContextForBusy)(state.fillState.form)) ])((function () {
                var $106 = !signatures;
                if ($106) {
                    return [  ];
                };
                return append([ p$prime([ text(Translate.lookupTranslation("save-before-preview")) ]), a([ Concur_React_Props["_id"]("signature-anchor") ])([  ]), map1(previewStateChangeF(state.fillState))(Widgets_FormPreview.renderPreview(state.fillState.preview)), div([ Concur_React_Props.className("signatures") ])((function () {
                    var $107 = length(state.fillState.signatures.sigs) > 0;
                    if ($107) {
                        return [ h1([ Concur_React_Props.className("signatures-heading") ])([ text(Translate.lookupTranslation("sign")) ]), map1(sigResultF(state.fillState))(Widgets_Signature_Group.signatureGroup(state.fillState.signatures)) ];
                    };
                    return [  ];
                })()), map1(commentResultF(state.fillState))(Widgets_Comments.runComments(state.fillState.comments)), map1(attachmentResultF(state.fillState))(Widgets_Attachments.runAttachments(state.fillState.attachments)), div([ Concur_React_Props.className("form-updated-times") ])([ p$prime([ text(Translate.lookupTranslation("form-created-at") + (" " + Internal_Luxon.prettyPrint(state.fillState.doc.created_at))) ]), p$prime([ text(Translate.lookupTranslation("form-updated-at") + (" " + Internal_Luxon.prettyPrint(state.fillState.doc.updated_at))) ]) ]) ])(Data_Array.catMaybes([ (function () {
                    if (busy) {
                        return new Data_Maybe.Just(div([ Concur_React_Props.className("loading-overlay step-3-loading-overlay") ])([ Widgets_Loading.loadingWidget ]));
                    };
                    return Data_Maybe.Nothing.value;
                })() ]));
            })()))));
        };
    };
};
var renderFormFill = function (signatures) {
    return function (busy) {
        return function (state) {
            return renderFormFillState(signatures)(busy)(state);
        };
    };
};
export {
    renderFormFill
};
//# sourceMappingURL=index.js.map
